module.exports = __webpack_public_path__ + "img/ref.cebe209e.png";